import {action, observable, runInAction} from 'mobx';
import GenericFormStore from '../../../stores/FormStore';
import {go} from '../../../utils/navigationUtility';
import request from '../../../utils/request';
import {SIGNUP_DEMO} from '../../../constants/urlConstants';

class RequestDemoStore extends GenericFormStore {
    @observable isRegistering = false;
    @observable form = {
        fields: {
            email: {
                value: '',
                error: '',
                rule: 'required|email'
            },
            name: {
                value: '',
                error: '',
                rule: 'required'
            },
            phone: {
                value: '',
                error: '',
                rule: 'phone'
            }
        },
        meta: {
            isValid: true,
            error: null,
        },
    };

    /**
     * Checks for abnormalities in the form before submitting to the server
     */
    _validateBeforeReq() {
        const {email, name} = this.form.fields;
        if (!email.value || !name.value || email.error || name.error) {
            this.form.meta.error = 'Please fill all the fields correctly';
            this._clearMetaError();
            return false;
        }

        return true;
    }

    _clearMetaError = () => {
        setTimeout(() => {
            runInAction(() => {
                this.form.meta.error = '';
            });
        }, 3500);
    };

    /**
     *
     * @param {*} role a string representing a teacher or a student. 'role' is not a form input field
     */
    @action
    async register(role) {
        if (!this._validateBeforeReq()) {
            return false;
        }

        const {fields} = this.form;
        this.isRegistering = true;
        const signUpFormFields = {};
        Object.keys(fields).forEach((field) => {
            signUpFormFields[field] = fields[field].value;
        });

        // await unauthenticatedAccess();
        await request(SIGNUP_DEMO, {method: 'POST', body: {...signUpFormFields, role}});
        runInAction(() => {
            this.isRegistering = false;
        });
        return true;
    }

    @action confirm = async () => {
        // Do something here
    };

    @action onClickDone = () => {
        go('/signin');
    };
}

const requestDemoStore = new RequestDemoStore();
export default requestDemoStore;
